import localeDataEn from '../translations/en.json';
import localeDataLv from '../translations/lv.json';
import localeDataRu from '../translations/ru.json';
import { i18nConstants } from '../_constants';
import config from '../config';

type LabelMap = { [key: string]: string };

const bundled: { [lang: string]: LabelMap } = {
    en: localeDataEn,
    lv: localeDataLv,
    ru: localeDataRu
};

type I18nState = {
    lang: string,
    messages: LabelMap,
    synchronized: boolean,
    overrides: { [lang: string]: LabelMap },
    editMode: boolean,
    editingKey: string | null
};

const initialState: I18nState = {
    lang: 'en',
    messages: localeDataEn,
    synchronized: false,
    overrides: { en: {}, lv: {}, ru: {} },
    editMode: false,
    editingKey: null
};

const supportedLanguages = ['LV', 'EN', 'RU'];

function computeMessages(lang: string, overrides: { [lang: string]: LabelMap }): LabelMap {
    const base: LabelMap = bundled[lang] || bundled['en'];
    return { ...base, ...(overrides[lang] || {}) };
}

export function i18n(state: I18nState = Object.assign({}, initialState), action: any) {
    switch (action.type) {
        case i18nConstants.CHANGE_LANGUAGE:
            if (action.data.lang === null || action.data.lang === undefined || !supportedLanguages.includes(action.data.lang.toString().toUpperCase())) {
                state.lang = 'en';
            } else {
                state.lang = action.data.lang;
            }
            localStorage.setItem(config.language, state.lang);

            state.messages = computeMessages(state.lang, state.overrides);

            return Object.assign({}, state);
        case i18nConstants.LABELS_FETCHED: {
            const labels: { [lang: string]: LabelMap } = action.data.labels || {};
            const overrides: { [lang: string]: LabelMap } = {
                en: labels.en || {},
                lv: labels.lv || {},
                ru: labels.ru || {}
            };
            state.overrides = overrides;
            state.messages = computeMessages(state.lang, overrides);

            return Object.assign({}, state);
        }
        case i18nConstants.LABEL_SAVED: {
            const { key, values } = action.data as { key: string, values: { [lang: string]: string } };
            const overrides: { [lang: string]: LabelMap } = {
                en: { ...(state.overrides.en || {}) },
                lv: { ...(state.overrides.lv || {}) },
                ru: { ...(state.overrides.ru || {}) }
            };
            Object.keys(values).forEach(lang => {
                if (!overrides[lang]) {
                    overrides[lang] = {};
                }
                overrides[lang][key] = values[lang];
            });
            state.overrides = overrides;
            state.messages = computeMessages(state.lang, overrides);

            return Object.assign({}, state);
        }
        case i18nConstants.SET_LABEL_EDIT_MODE:
            state.editMode = !!action.data.editMode;

            return Object.assign({}, state);
        case i18nConstants.SET_EDITING_LABEL_KEY:
            state.editingKey = action.data.key ?? null;

            return Object.assign({}, state);
        default:
            return state;
    }
}
